/* @ngInject */
function AnalyticsErrorDataFrame ($scope, IntercomService) {
  $scope.error = {
    activeButton: 'REFRESH',
    limitRefresh: 3,
    count: 0
  }

  const api = {
    _checkActiveErrorButton,
    _getSizeTitle
  }

  this.getApi = () => api

  activate()

  function activate () {
    $scope.titleSize = api._getSizeTitle($scope.type)
  }

  $scope.refresh = () => {
    $scope.error.activeButton = api._checkActiveErrorButton()
    $scope.flags.hasError = false
    $scope.flags.loading = true

    $scope.refreshCallback()
  }

  $scope.openIntercomChat = () => {
    IntercomService.show()
  }

  function _checkActiveErrorButton () {
    $scope.error.count = $scope.error.count + 1

    return $scope.error.count >= $scope.error.limitRefresh ? 'CHAT' : 'REFRESH'
  }

  function _getSizeTitle (type) {
    if (type === 'CARD') {
      return 'sm'
    }

    return 'md'
  }
}

export { AnalyticsErrorDataFrame }
